var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.activeActivities),function(item){return _c(item.component,{key:item.key,tag:"component",staticClass:"pointer",style:(_vm.getStyle(item)),on:{"close":function($event){return _vm.doClose(item)}},nativeOn:{"click":function($event){return item.go.apply(null, arguments)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }